export const pt = {
  brand: 'Velha Zap',
  tagline: 'Jogo da velha por link — mande no Zap e jogue em turnos.',
  yourNickname: 'Seu apelido',
  nicknamePlaceholder: 'Ex.: Ana',
  startGame: 'Começar e jogar',
  makeFirstMove: 'Faça a primeira jogada no tabuleiro',
  shareChallenge: 'Desafiar amigo',
  shareTurn: 'Enviar jogada',
  shareResult: 'Compartilhar resultado',
  copyLink: 'Link copiado!',
  shareFailed: 'Não foi possível compartilhar. Tente copiar o link.',
  yourTurn: 'Sua vez ({mark})',
  waitShare: 'Aguarde a jogada de {name}. Compartilhe o link.',
  waitingOpponentName: 'o adversário',
  guestNicknameTitle: 'Como devemos te chamar?',
  guestNicknameCta: 'Entrar no jogo',
  youAre: 'Você é {mark}',
  vs: 'vs',
  winner: '{name} venceu!',
  draw: 'Empate!',
  rematch: 'Revanchinha',
  newGame: 'Novo jogo',
  invalidLink: 'Este link de partida é inválido.',
  staleLink: 'Este link está desatualizado. Peça o link mais recente da conversa.',
  backHome: 'Voltar ao início',
  themeSystem: 'Sistema',
  themeLight: 'Claro',
  themeDark: 'Escuro',
  language: 'Idioma',
  playingAs: 'Jogando como {name} ({mark})',
  needNickname: 'Informe um apelido para continuar.',
  shareTextTurn: 'Sua vez no Velha Zap!',
  shareTextChallenge: 'Te desafiei no Velha Zap!',
  shareTextResult: 'Partida terminada no Velha Zap!',
  shareTextRematch: 'Revanchinha no Velha Zap — agora é sua vez de começar!',
} as const;

export type MessageKey = keyof typeof pt;
